module.exports = __webpack_public_path__ + "img/d5cd5ae.jpg";